import { render, staticRenderFns } from "./SoundsIcon.vue?vue&type=template&id=1a9fe596&scoped=true&"
import script from "./SoundsIcon.vue?vue&type=script&lang=js&"
export * from "./SoundsIcon.vue?vue&type=script&lang=js&"
import style0 from "./SoundsIcon.vue?vue&type=style&index=0&id=1a9fe596&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9fe596",
  null
  
)

export default component.exports